<template>
  <div class="help-popin">
    <div class="help-wrapper">
      <button type="button" class="help-popin-close" @click="$emit('close')">
        <i class="ico ico-cross"></i>
        <span class="hide-access">{{ Translator('accessibility.popin.close') }}</span>
      </button>
      <perfect-scrollbar>
        <div class="help-popin-container wysiwyg">
          <div v-if="isArray">
            <div class="help-popin-content" v-for="data in datas" :key="data.title">
              <div v-if="data.content" v-html="data.content"></div>
            </div>
          </div>
          <div class="help-popin-content" v-else>
            <div v-if="datas.content" v-html="datas.content"></div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .help-popin {
    z-index: 5;
    @include mobile {
      @include fixed;
      background-color: rgba($black, .5);
    }
    @include tablet {
      position: absolute;
      left: rem(50);
      width: calc(90% - #{rem(95)});
    }
    @include desktop {
      width: calc(70% - #{rem(95)});
      left: rem(60);
    }
    @include desktop-xl {
      left: rem(80);
      width: calc(70% - #{rem(125)});
    }
    .help-wrapper {
      @include container;
      @include vertical-spacing-bottom;
      box-shadow: 0 rem(3) rem(20) rgb($black, 15%);
      width: 100%;
      @include mobile {
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 0;
        max-height: 95vh;
        max-width: 95vw;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      @include tablet {
        max-height: rem(500);
      }
    }
    .ps {
      max-height: 95vh;
      @include tablet {
        max-height: rem(500);
      }
    }
    .help-popin-close {
      @include resetBtn;
      position: absolute;
      z-index: 2;
      top: rem(10);
      right: rem(10);
      width: rem(25);
      height: rem(25);
      line-height: rem(25);
      font-size: rem(20);
      color: $black;
      transition: color $transition-out-hover;
      &:hover, &:focus {
        color: $color-second;
        transition: color $transition-in-hover;
      }
    }
    .help-popin-content + .help-popin-content {
      margin-top: rem(30);
    }
    .help-popin-container {
      padding: rem(30);
    }
  }
</style>
<script>
export default {
  props: ['datas', 'origin', 'scroll'],
  name: 'help',
  data () {
    return {
      isArray: false
    }
  },
  created() {
    this._resize = this._resize.bind(this);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._resize);
  },
  mounted() {
    this.onUpdate();
  },
  watch: {
    origin: function() {
      this.onUpdate();
    }
  },
  methods: {
    onUpdate() {
      this.isArray = Array.isArray(this.datas);
      window.addEventListener('resize', this._resize);
      if(window.innerWidth >= 768) {
        const positions = this.origin.getBoundingClientRect();
        this.$el.style.top = `${positions.top + this.scroll + 52}px`;
      }
    },

    _resize() {
      this.$emit('close');
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
}
</script>
